import PropTypes from 'prop-types';
import classNames from 'classnames';
import { getMonthName } from '../../../utils/date';
import ClimateWeatherNugget from './climateWeatherNugget';
import './climateWeatherNuggetList.scss';

const MONTHS_TO_SHOW = 5;
const OFFSET = Math.floor(MONTHS_TO_SHOW / 2);

const getMonthIndices = (currentMonth, count) => {
  const indices = [];
  const start = currentMonth - Math.floor(count / 2);
  for (let i = 0; i < count; i += 1) {
    indices.push(((start + i) % 12 + 12) % 12);
  }
  return indices;
};

const ClimateWeatherNuggetList = ({
  climate = {},
  siteId = 1,
  currentMonth = 0,
  multiMonth = false,
}) => {
  const temperature = climate?.temperature || {};
  const day = temperature.day || [];
  const night = temperature.night || [];

  if (!multiMonth) {
    return (
      <div className="gw-weather-nugget-list">
        <ClimateWeatherNugget
          month={getMonthName(currentMonth, siteId)}
          day={day[currentMonth]}
          night={night[currentMonth]}
        />
      </div>
    );
  }

  const months = getMonthIndices(currentMonth, MONTHS_TO_SHOW);

  return (
    <div className="gw-weather-nugget-list gw-weather-nugget-list--multi">
      {months.map((i, idx) => (
        <div
          key={i}
          className={classNames('gw-weather-nugget-list__item', {
            'gw-weather-nugget-list__item--center': idx === OFFSET,
          })}
        >
          <ClimateWeatherNugget
            month={getMonthName(i, siteId)}
            day={day[i]}
            night={night[i]}
          />
        </div>
      ))}
    </div>
  );
};

ClimateWeatherNuggetList.propTypes = {
  climate: PropTypes.shape({
    temperature: PropTypes.shape({
      day: PropTypes.arrayOf(PropTypes.number),
      night: PropTypes.arrayOf(PropTypes.number),
    }),
  }),
  siteId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  currentMonth: PropTypes.number,
  multiMonth: PropTypes.bool,
};

export default ClimateWeatherNuggetList;
